export enum ECustomerSearchTypes {
  NAME = 'customer_name',
  EMAIL = 'customer_email',
  DOCUMENT = 'customer_document',
}

export enum ECancelTabs {
  CANCEL = 'cancel',
  STATISTICS = 'statistics',
}

export enum ECancelChartTypes {
  CURRENCY = 'currency',
  PERCENTAGE = 'percentage',
}

export interface ICancelFilter {
  id: string;
  date: [string, string];
  customer?: string;
  customer_type: ECustomerSearchTypes;
  product_id: number[];
  invoice_id: string;
  reason_id: string[];
  canceled_at_initial?: string;
  canceled_at_final?: string;
}

export interface ICancelChart {
  subscriptions_total: number;
  subscriptions_amount: number;
  chart: Array<{
    total: number;
    reason: string;
    amount: number;
    percentage: number;
  }>;
}
